import Vue from 'vue'
import App from './App.vue'
import api from "@/api.js";
import router from './router'
import store from './store'
import i18n from './i18n'
import vuetify from './plugins/vuetify';
import "@/../public/posidcs.css"
import filters from './filters.js';
import VueCryptojs from 'vue-cryptojs'

Vue.use(VueCryptojs);
Vue.use(require('vue-moment'));

Vue.config.productionTip = false
Vue.prototype.$api = api;

filters.forEach(f => {
  Vue.filter(f.name, f.func)
})
const vm = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
api.setVm(vm);